// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var PropertyWizardRelayPreviewQuery_graphql = require("../../../__generated__/PropertyWizardRelayPreviewQuery_graphql.bs.js");

var convertVariables = PropertyWizardRelayPreviewQuery_graphql.Internal.convertVariables;

var convertResponse = PropertyWizardRelayPreviewQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = PropertyWizardRelayPreviewQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, PropertyWizardRelayPreviewQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertyWizardRelayPreviewQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(PropertyWizardRelayPreviewQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(PropertyWizardRelayPreviewQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(PropertyWizardRelayPreviewQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(PropertyWizardRelayPreviewQuery_graphql.node, convertVariables);

var Query_forSalePropertyTypeEnumV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var Query_forSalePropertyTypeEnumV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var Query_leaseLengthValue_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.leaseLengthValue_decode;

var Query_leaseLengthValue_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.leaseLengthValue_fromString;

var Query_mlsListingTypeV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.mlsListingTypeV5_decode;

var Query_mlsListingTypeV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.mlsListingTypeV5_fromString;

var Query_rentalPropertyTypeEnumV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var Query_rentalPropertyTypeEnumV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var Query_showingTypeV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.showingTypeV5_decode;

var Query_showingTypeV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.showingTypeV5_fromString;

var Query = {
  forSalePropertyTypeEnumV5_decode: Query_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: Query_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: Query_leaseLengthValue_decode,
  leaseLengthValue_fromString: Query_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: Query_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: Query_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: Query_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: Query_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: Query_showingTypeV5_decode,
  showingTypeV5_fromString: Query_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function usePreloadPreviewQuery() {
  var environment = RescriptRelay.useEnvironmentFromContext();
  return function (propertyData) {
    $$fetch(environment, {
          propertyData: propertyData
        }, (function (result) {
            
          }), undefined, undefined);
  };
}

exports.Query = Query;
exports.usePreloadPreviewQuery = usePreloadPreviewQuery;
/* use Not a pure module */
